import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { ArrowRight, Sparkles } from 'lucide-react';
import { Button } from './ui/button';

const Hero = () => {
  const { t } = useLanguage();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="min-h-screen flex items-center justify-center bg-transparent pt-20 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(56,189,248,0.18),transparent_40%),radial-gradient(circle_at_80%_15%,rgba(20,184,166,0.16),transparent_35%),radial-gradient(circle_at_50%_85%,rgba(14,116,144,0.2),transparent_45%)]" />
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="text-center space-y-8 relative z-10">
          {/* Decorative element */}
          <div className="flex justify-center mb-8">
            <div className="relative">
              <div className="w-24 h-24 bg-gradient-to-br from-cyan-400 to-teal-500 rounded-full opacity-25 blur-2xl animate-pulse"></div>
              <Sparkles className="w-12 h-12 text-cyan-300 absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" />
            </div>
          </div>

          {/* Main headline */}
          <div className="space-y-4">
            <h1 className="text-5xl md:text-7xl font-bold text-slate-100 leading-tight">
              {t.hero.headline}
              <br />
              <span className="bg-gradient-to-r from-cyan-300 via-teal-300 to-sky-400 bg-clip-text text-transparent">
                {t.hero.headlineAccent}
              </span>
            </h1>
            <p className="text-lg md:text-xl text-slate-300 max-w-2xl mx-auto leading-relaxed">
              {t.hero.subtitle}
            </p>
          </div>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-8">
            <Button
              size="lg"
              onClick={() => scrollToSection('portfolio')}
              className="bg-cyan-500 hover:bg-cyan-600 text-slate-950 hover:text-white px-8 py-6 text-base font-semibold shadow-lg shadow-cyan-500/30 hover:shadow-xl transition-all duration-200 hover:-translate-y-1"
            >
              {t.hero.cta1}
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <Button
              size="lg"
              variant="outline"
              onClick={() => scrollToSection('contact')}
              className="border-2 border-cyan-500/40 bg-slate-900/40 hover:bg-slate-800 hover:border-cyan-300 text-slate-100 hover:text-white px-8 py-6 text-base font-medium transition-all duration-200 hover:-translate-y-1"
            >
              {t.hero.cta2}
            </Button>
          </div>

          {/* Tech badges */}
          <div className="flex flex-wrap items-center justify-center gap-3 pt-12">
            {['AI', 'Full-Stack', 'React', 'Python', 'Node.js'].map((tech) => (
              <span
                key={tech}
                className="px-4 py-2 bg-slate-900/70 border border-cyan-500/30 rounded-full text-sm font-medium text-cyan-100 shadow-sm hover:shadow-md transition-shadow duration-200"
              >
                {tech}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
